<template>
     <LayoutPage>
         <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :description="$t('actualLandPlanIdPage.description')"
                :title="$t('actualLandPlanIdPage.title')"
            />
        </template>

        <template v-slot:content>
            <div class="mm-section box box--space-vertical">
                <div class="mm-section-content">
                    <div class="container-fluid w-100">

                        <div class="box box--space-vertical">
                            <router-link v-if="from"
                                :to="from"
                                class="mm-link mm-link--icon-left-space-s">
                                <i class="icon icon-arrow-left"></i> {{$t('actualLandPlanIdPage.backButton')}}
                            </router-link>

                            <router-link
                                v-if="!from"
                                :to="localeRoute({name: 'news_actual_landplans'})"
                                class="mm-link mm-link--icon-left-space-s">
                                <i class="icon icon-arrow-left"></i> {{$t('actualLandPlanIdPage.backToPlans')}}
                            </router-link>
                        </div>

                        <app-spinner v-if="dataRequestState === 'request'"/>

                        <div v-else-if="dataRequestState === 'failure'">
                            <h1 class="headline headline--second">
                                <Error404 />
                            </h1>
                        </div>


                        <div v-else>
                            <div class="row" v-if="data">

                                <div class="col-md-7 box box--space-bottom">
                                    <div class="box box--space-bottom">
                                        <div class="row align-items-center">
                                            <div class="col-auto"
                                                style="width: 80px"
                                                :class="{'d-none': !data.hasPlan}">
                                                <img :src="imageFileUrl" alt="" width="80"/>
                                            </div>
                                            <div class="col">
                                                <h1 class="headline headline--second">
                                                    <span id="underline-heading">
                                                        {{data.name}}
                                                    </span> - {{$t('actualLandPlanIdPage.heading')}}
                                                </h1>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="data">
                                        <div class="col-md-6 col-lg-4">
                                            <div class="box box--space-bottom">
                                                <div class="text--grey">
                                                    {{$t('actualLandPlanIdPage.address')}}:
                                                </div>
                                                <span class="text--basic-paragraph">
                                                    {{data.office_name}} <br>
                                                    {{data.office_street}} <br>
                                                    {{data.office_zip_code}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="box box--space-bottom">
                                                <div class="text--grey">
                                                    {{$t('actualLandPlanIdPage.phone')}}:
                                                </div>
                                                <span class="text--basic-paragraph">
                                                    {{data.phone}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="box box--space-bottom">
                                                <div class="text--grey">
                                                    {{$t('actualLandPlanIdPage.email')}}:
                                                </div>
                                                <span class="text--basic-paragraph">
                                                    {{data.email}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="box box--space-bottom">
                                                <div class="text--grey">
                                                    {{$t('actualLandPlanIdPage.major')}}:
                                                </div>
                                                <span class="text--basic-paragraph">
                                                    {{data.mayor}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <a :href="data.web"
                                        target="_blank"
                                        class="button transparent--button">
                                        {{$t('actualLandPlanIdPage.web')}} {{data.name}}
                                    </a>
                                </div>

                                <div class="col-md-5">
                                    <div class="box box--space-bottom">
                                        <div class="image-mask">
                                            <img
                                                v-if="$te('actualLandPlanIdPage.image.responsiveImage')"
                                                :src="$t('actualLandPlanIdPage.image.responsiveImage.src')"
                                                :srcset="$t('actualLandPlanIdPage.image.responsiveImage.srcset')"
                                                style="width: 100%" />
                                            <div class="image-mask__mask-inner"></div>
                                            <div class="image-mask__mask">
                                                <a @click="openUP"
                                                    class="image-mask__button">
                                                    <span class="button button--xl normal--button button--small-text button--uppercase button--shadow">
                                                        {{$t('actualLandPlanIdPage.openButton')}}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>
     </LayoutPage>

</template>

<script>
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import { getRegion, openUP } from '@/services/MapsfyApi';
import Error404 from '@/components/ui/Error/Error404';

export default {
    components: {
        LayoutPage,
        BannerSmallerWithSearchAndButton,
        Error404
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from && from.name) {
                vm.from = from;
            }
        });
    },
    created() {
        this.getRegion(this.regionId, this.districtId, this.cityId);
    },
    watch: {
        '$route.params': function (r) {
            this.getRegion(r.regionId, r.districtId, r.cityId);
        }
    },
    computed: {
        regionId() {
            return this.$route.params.region;
        },
        districtId() {
            return this.$route.params.district;
        },
        cityId() {
            return this.$route.params.city;
        },
        planApiUrl() {
            return `${this.regionId}/${this.districtId}/${this.cityId}`;
        },
        imageFileUrl() {
            return `/css/images/erby/${this.getPlanApiUrl(
                this.regionId,
                this.districtId,
                this.cityId
            )}.jpg`;
        }
    },
    data() {
        return {
            from: null,
            data: null,
            dataRequestState: null
        }
    },
    methods: {
        getPlanApiUrl(regionId, districtId, cityId) {
            return `${regionId}/${districtId}/${cityId}`;
        },
        openUP() {
            if (this.data) {
                this.$router.push({name: 'mapApp'});
                openUP(this.data.layerIds, this.data.bbox);
            }
        },
        getRegion(regionId, districtId, cityId) {
            this.dataRequestState = 'request';
            getRegion(this.getPlanApiUrl(regionId, districtId, cityId))
                .then(res => {
                    if (res && res.length) {
                        this.data = res[0];
                        this.dataRequestState = "success";
                        return;
                    }

                    this.dataRequestState = "failure";
                })
                .fail(() => {
                    this.dataRequestState = "failure";
                });

        }
    }
}
</script>

<style lang="scss" scoped>
.image-mask__mask {
    background-color: rgba(0,174,186,0.1);
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 100%;
}

.image-mask__mask-inner {
    border: 1px solid #00AEBA;
    position: absolute;
    top: 1rem;
    left: 1rem;
    right: 1rem;
    bottom: 1rem;
}

.image-mask {
    position: relative;
}

.image-mask__button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

#underline-heading::before  {
    content: "";
    position: absolute;
    width: 50px;
    top: 32px;
    border-bottom: 2px solid #00aeba;
}

@media (min-width: 992px) {
    #underline-heading::before  {
        top: 43px;
    }
}
</style>